import { render, staticRenderFns } from "./StaticPageLayoutPreview.vue?vue&type=template&id=000156c5&scoped=true&"
import script from "./StaticPageLayoutPreview.vue?vue&type=script&lang=js&"
export * from "./StaticPageLayoutPreview.vue?vue&type=script&lang=js&"
import style0 from "./StaticPageLayoutPreview.vue?vue&type=style&index=0&id=000156c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000156c5",
  null
  
)

export default component.exports